var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border-2 border-indomascot-old-blue p-2 shadow-inner"},[_c('span',{staticClass:"font-bold text-indomascot-old-blue"},[_vm._v("MENU")])])
}]

export { render, staticRenderFns }